import React from 'react'
import styles from '../shared.scss'
import cx from 'classnames'
import { icons } from '../icons'
import { FormattedMessage as T, defineMessages } from 'react-intl'
import { useFormatMessage } from 'lib/localization'

export const messages = defineMessages({
  splitRoute: {
    id: 'RouteTools.splitRoute',
    defaultMessage: 'Split Route'
  }
})

export const RouteTools = ({
  needsUpgrade, toolsDisabled, outAndBack, duplicate, splitRoute, trace, showSelectionTools, setModalConfirmation
}) => {
  const fm = useFormatMessage()
  return (
    <div>
      <div className={styles.title}><T id='RouteTools.routeTools' defaultMessage='Route Tools' /></div>
      <div className={cx(styles.boxes, styles.routeTools, toolsDisabled && styles.disabled)}>
        <div onClick={() => !toolsDisabled && setModalConfirmation('reverseRoute')}>
          {icons.reverseRoute}
          <div><T id='RouteTools.reverseRoute' defaultMessage='Reverse Route' /></div>
        </div>
        <div onClick={toolsDisabled ? undefined : outAndBack}>
          {icons.outAndBack}
          <div><T id='RouteTools.outAndback' defaultMessage='Out and Back' /></div>
        </div>
        <div onClick={toolsDisabled ? undefined : duplicate} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.duplicate}
          <div><T id='RouteTools.duplicate' defaultMessage='Duplicate' /></div>
        </div>
        <div onClick={toolsDisabled ? undefined : splitRoute} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.splitRoute}
          <div>{fm(messages.splitRoute)}</div>
        </div>
        <div onClick={toolsDisabled ? undefined : trace} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.autoTrace}
          <div><T id='RouteTools.trace' defaultMessage='Trace' /></div>
        </div>
        <div onClick={toolsDisabled ? undefined : showSelectionTools}>
          {icons.selectionTools}
          <div><T id='RouteTools.selectionTools' defaultMessage='Selection Tools' /></div>
        </div>
      </div>
      <div className={styles.title}><T id='RouteTools.clearAll' defaultMessage='Clear All' /></div>
      <div className={cx(styles.boxes, styles.smallBoxes, toolsDisabled && styles.disabled)}>
        <div onClick={() => !toolsDisabled && setModalConfirmation('clearCues')}><T id='RouteTools.cues' defaultMessage='Cues' /></div>
        <div onClick={() => !toolsDisabled && setModalConfirmation('clearPoi')}><T id='RouteTools.POI' defaultMessage='POI' /></div>
      </div>
    </div>
  )
}
